import React, { useEffect, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import DashboardCard from '../../../component/Produzioni/DashboardCard';
import TableInputPigiatura from '../../../component/Produzioni/TableInputPigiatura';
import TableInputFeildFermentazione from '../../../component/Produzioni/TableInputFeildFermentazione';
import TrattamentiFrom from '../../../component/Produzioni/TrattamentiFrom';
import { resetFormSubmit, storeFormData } from '../../../features/produzioniFormData/produzioniFormDataSlice';
import produzioniFormAPI from '../../../services/produzioniFormApi';
import { useDispatch, useSelector } from 'react-redux';

const FermentazioneeMacerazione = ({option, activeStep, setActiveStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const submitForm = useSelector((state) => state.produzioniForm.submitForm);

    const [tableData, setTableData] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, fermentazione: null, temp_fermentazione: "", ph_del_mosto: "", alcol_potenziale: "", densita_mosto: "" },
    ]);

    const [treatment, setTreatment] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, pro_treatment_id: "", tratt_date: null, pro_utilizzato: "", pro_qty: "", mod_di_applicazione: "", operatore_id: "", sicurezza: "" }
    ]);

    const data = {
        id: 1,
        title: "Fermentazione e macerazione",
        description:
            "Controlla costantemente temperatura e acidità per garantire una fermentazione stabile e controllata.",
        buttonText: "Completa fase",
    };
    const dummyData = {

        temperatureCompliance: tableData.reduce((acc, item) => acc + Number(item.temp_fermentazione), 0)/ tableData.length + "°",
        totalCollected: tableData.reduce((acc, item) => acc + Number(item.ph_del_mosto), 0)/ tableData.length + "°",
        discardedGrapes: tableData.reduce((acc, item) => acc + Number(item.alcol_potenziale), 0)/ tableData.length + " %",
        mosto: tableData.reduce((acc, item) => acc + Number(item.densita_mosto), 0)/ tableData.length + "°",
        tasks: [
            "Aggiunta di lieviti",
            "Controllo temperatura e acidità",
            "Monitoraggio dello stato della fermentazione",
        ],
    };

    const infoFields = [
        { label: "Temperatura fermetazione", key: dummyData.temperatureCompliance, },
        { label: "Ph del mosto", key: dummyData.totalCollected },
        { label: "Alcol potenziale", key: dummyData.discardedGrapes, showIcon: true },
        { label: "Densità mosto", key: dummyData.mosto, showIcon: true },
    ];

    const fetchDataForUpdate = async () => {
        try {
          const payload = {
            company_id: localStorage.getItem('company_id'),
            step: activeStep,
            prod_id: singleProduzioneID,
          };
    
          const response = await produzioniFormAPI.getSingleStepFormData(payload);
          console.log(response, "response racolta")
          if (response?.data.data.fermentazione?.length) {
            const existingTable = response.data.data.fermentazione;
            setTableData(existingTable);
          }
          if (response?.data.data.production_step_treatment?.length) {
            const existingTreatment = response.data.data.production_step_treatment;
            setTreatment(existingTreatment);
          }
        } catch (error) {
          console.error("Error fetching single step form data:", error);
        }
      };
      
      useEffect(() => {
          fetchDataForUpdate();
      }, []);
    
    const onSubmit = async (tableData, treatment) => {
        const data = {
            step: activeStep,
            forms: {
                fermentazione: tableData,
                production_step_treatment: treatment
            }
        }
        console.log("Submitted data:", data);
        try {
              await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);
        
            setActiveStep((prev) => prev + 1);
          } catch (error) {
            fetchDataForUpdate();
            console.error('Error submitting form data:', error);
          }
    };

    useEffect(() => {
        if (submitForm) {
            onSubmit(tableData, treatment);
            dispatch(resetFormSubmit());
        }
    }, [submitForm, dispatch]);

    return (
        <>
            <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
            <DashboardCard dummyData={dummyData} infoFields={infoFields} />
            <TableInputFeildFermentazione 
            option={option} 
            rows={tableData}
                setRows={setTableData}
                activeStep={activeStep}
                />
            <TrattamentiFrom
            option={option} 
            rows={treatment}
                setRows={setTreatment}
                activeStep={activeStep}
                />
        </>
    )
}

export default FermentazioneeMacerazione